import { render, staticRenderFns } from "./CmpControlForm1.vue?vue&type=template&id=2fa8dca1&scoped=true&"
import script from "./CmpControlForm1.vue?vue&type=script&lang=js&"
export * from "./CmpControlForm1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa8dca1",
  null
  
)

export default component.exports